import React from 'react'
// import CustomTable from '../../common/customTable'
// import MyImage from '../../common/myImage'
import styles from './style.module.scss'
import CustomTable from '../common/customTable'
// import MyImage from '@shared/components/myImage'
import { OlympicsLogo } from '@shared/components/ctIcons'
import PropTypes from 'prop-types'

export default function MedalTable({ data }) {
  const indiaData = data?.aCountryStats?.find((ele) => ele?.Country === 'India')

  const indiaRow = indiaData ? [indiaData.Rank, <div key="india" className="d-flex"><div style={{ minWidth: 52, textAlign: 'left' }}>{indiaData.Country}</div></div>, indiaData.Gold, indiaData.Silver, indiaData.Bronze, indiaData.Total] : []

  const bodyData = data?.aCountryStats?.slice(0, 10)?.filter((ele) => ele?.Country !== 'India').map((ele, index) => {
    return [
      ele.Rank,
      <div key={index} className="d-flex">
        <div style={{ minWidth: 52, textAlign: 'left' }}>{ele.Country}</div>
      </div>,
      ele.Gold,
      ele.Silver,
      ele.Bronze,
      ele.Total
    ]
  })

  const tableData = {
    header: ['#', 'Team', 'G', 'S', 'B', 'Total'],
    body: indiaRow.length ? [indiaRow, ...bodyData] : bodyData
  }

  return (
    <div className={styles.leaguePointsTable}>
      <div className={`d-flex align-items-center ${styles.tableBanner}`}>
        <OlympicsLogo />
        <div className={styles.tableCntr}>
          <div className={styles.tableTitle}>Paris {data?.nYear}</div>
          <div className={styles.tableSubTitle}>Medal Table</div>
        </div>
      </div>
      <CustomTable table={tableData} noData={data?.aCountryStats.length <= 0} smallTable />
    </div>
  )
}

MedalTable.propTypes = {
  data: PropTypes.object
}
